/**
 * Head Feature Routes (Static Pages)
 * Mirrors: interactions-uhci-webui2/src/app/head/head-routing.module.ts (static routes)
 *
 * Simple single-page routes:
 * - /terms-of-use
 * - /privacy-policy
 * - /SiteMap
 * - /TinList
 * - /contactus
 * - /AccessDenied
 */

import { lazy } from 'react';
import { RouteConfig } from '../../types';

const HomePage = lazy(() =>
  import('@src/apps/HomePage/HomePage').then((m) => ({ default: m.HomePage }))
);
const TermsOfUse = lazy(() =>
  import('@src/apps/TermsOfUse/TermsOfUse').then((m) => ({ default: m.TermsOfUse }))
);
const PrivacyPolicy = lazy(() =>
  import('@src/apps/PrivacyPolicy/PrivacyPolicy').then((m) => ({ default: m.PrivacyPolicy }))
);
const ContactUs = lazy(() =>
  import('@src/apps/ContactUs/ContactUs').then((m) => ({ default: m.ContactUs }))
);
const AccessDenied = lazy(() =>
  import('@web/auth/AccessDenied').then((m) => ({ default: m.AccessDenied }))
);

/**
 * Head feature routes - static and utility pages only
 * Layout: protected for in-app static pages
 * Guards: auth on most routes
 */
export const headRoutes: RouteConfig[] = [
  // Home
  {
    path: 'myhome',
    component: HomePage,
    layout: 'protected',
    guards: ['auth', 'vendor', 'provider'],
    data: {
      title: 'Home',
      breadcrumb: 'Home',
      preload: false,
      delay: false,
      checkRoleFor: 'UHCI_Project',
    },
  },

  // Terms of Use
  {
    path: 'myhome/terms-of-use',
    component: TermsOfUse,
    layout: 'protected',
    guards: ['auth', 'vendor'], // From legacy app: canActivate: [AuthGuard, VendorRoleGuard]
    data: {
      title: 'Terms of Use',
      breadcrumb: 'Terms of Use',
    },
  },

  // Privacy Policy
  {
    path: 'myhome/privacy-policy',
    component: PrivacyPolicy,
    layout: 'protected',
    guards: ['auth', 'vendor'], // From legacy app: canActivate: [AuthGuard, VendorRoleGuard]
    data: {
      title: 'Privacy Policy',
      breadcrumb: 'Privacy Policy',
    },
  },

  // Contact Us
  {
    path: 'myhome/contactus',
    component: ContactUs,
    layout: 'protected',
    guards: ['auth', 'vendor'], // From legacy app: canActivate: [AuthGuard, VendorRoleGuard]
    data: {
      title: 'Contact Us',
      breadcrumb: 'Contact Us',
    },
  },

  // Access Denied
  {
    path: 'AccessDenied',
    component: AccessDenied,
    layout: 'public', // Error pages usually don't need nav
    guards: [], // No guards for error page
    data: {
      title: 'Access Denied',
      breadcrumb: 'Access Denied',
      showAppFooter: true,
    },
  },
];

export default headRoutes;
